module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3_text"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements"
  }, [_vm._v("I’d like to thank all the good folks from the American pork industry for creating such a wonderful product to work with. Thanks to Sandi for putting up with me and tasting all those pork chops. Thanks to Bill LeBlond, Amy Treadwell, Doug Ogan, Marie Oishi, Vanessa Dina, Tera Killip, Peter Perez, and David Hawk at Chronicle Books for keeping me around and making me look so good. Thanks to Scott Mendel for always finding a way to make things work. Last, but not least, thanks to Traci Rodemeyer for all the help and friendship.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-760cf3d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06acknowledgments.vue
// module id = 72
// module chunks = 0